import React, { useState } from 'react';

const Notifications = ({ notifications }) => {
  const [showAll, setShowAll] = useState(false);
  const visibleNotifications = showAll ? notifications : notifications.slice(0, 3);

  return (
    <div className="bg-white rounded-2xl shadow-sm p-6 w-full mb-6">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-lg font-medium text-gray-900">Notifications</h2>
        <span className="text-xs text-red-500 font-semibold">{notifications.length} notifications</span>
      </div>
      <div className="max-h-48 overflow-y-auto space-y-4">
        {visibleNotifications.map((n, idx) => (
          <div key={idx} className="mb-2 last:mb-0">
            <div className="font-semibold text-gray-800 mb-1">{n.title}</div>
            <div className="text-sm text-gray-600 mb-1">{n.message}</div>
            <div className="text-xs text-gray-400">{n.date}</div>
          </div>
        ))}
      </div>
      {notifications.length > 3 && (
        <button
          className="mt-2 text-blue-500 text-sm font-medium hover:underline"
          onClick={() => setShowAll((v) => !v)}
        >
          {showAll ? 'Show less' : 'Show all'}
        </button>
      )}
    </div>
  );
};

export default Notifications; 